import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { parse, format } from 'date-fns';
import { getLastThreeDays } from './helper';

const CustomCalendarPicker = ({ dateFromHubs, value, onChange, className, error }) => {
  // console.log(dateFromHubs);
  const includeDates = [
    // ...dateFromHubs?.map(date => parse(date?.split('T')[0], 'yyyy-MM-dd', new Date())) || [],
    ...getLastThreeDays()
  ];
  const todadate = new Date().toISOString().split('T')[0] + 'T00:00:00.000Z';
  includeDates.push(todadate);
  const selectedDate = value ? parse(value, 'yyyy-MM-dd', new Date()) : null;


  // Add yesterday's date
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  includeDates.push(yesterday.toISOString().split('T')[0] + 'T00:00:00.000Z');

  // Add day before yesterday's date
  const dayBeforeYesterday = new Date();
  dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);
  includeDates.push(dayBeforeYesterday.toISOString().split('T')[0] + 'T00:00:00.000Z');

  const handleChange = (date) => {
    onChange(date ? format(date, 'yyyy-MM-dd') : '');
  };

  console.log(includeDates, "includeDates");
  return (
    <DatePicker
      selected={selectedDate}
      onChange={handleChange}
      includeDates={includeDates}
      className={`${className} ${error ? 'border-red-500' : ''}`}
      dateFormat="MMM dd, yyyy"
      placeholderText="Select a date"
      calendarClassName="bg-gray-800 text-white"
      popperClassName="custom-popper"
    />
  );
};

export default CustomCalendarPicker;